const LOCALE = "es-AR";
const CURRENCY_STYLE = "currency";
const CURRENCY_CODE = "ARS";
const MIN_FRACTION_DIGITS = 0;
const MAX_FRACTION_DIGITS = 2;

export const formatNumberToPrice = (number) =>
  new Intl.NumberFormat(LOCALE, {
    style: CURRENCY_STYLE,
    currency: CURRENCY_CODE,
    minimumFractionDigits: MIN_FRACTION_DIGITS,
    maximumFractionDigits: MAX_FRACTION_DIGITS,
  }).format(number || 0);

export const formatNumberToPercentage = (number) =>
  new Intl.NumberFormat(LOCALE, {
    style: "percent",
    minimumFractionDigits: MIN_FRACTION_DIGITS,
    maximumFractionDigits: MAX_FRACTION_DIGITS,
  }).format(number || 0);

export const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

export const isEmptyValue = (value) => !hasValue(value);

const PERCENT_INPUT_SCALE = 100;
const PERCENT_INPUT_PRECISION = 100;

export const fractionToPercentInput = (value) =>
  hasValue(value)
    ? Math.round(value * PERCENT_INPUT_SCALE * PERCENT_INPUT_PRECISION) /
      PERCENT_INPUT_PRECISION
    : value;

export const percentInputToFraction = (value) =>
  hasValue(value) ? parseFloat(value) / PERCENT_INPUT_SCALE : null;
